var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.boxName == 'goal' ? 'auto-overflow' : 'online-overflow'},[_c('span',[_vm._v(_vm._s(_vm.userName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }